export const GET_WORKKARD_SEARCH_LIST_REQUEST="GET_WORKKARD_SEARCH_LIST_REQUEST";
export const GET_WORKKARD_SEARCH_LIST_SUCCESS="GET_WORKKARD_SEARCH_LIST_SUCCESS";

export const FETCH_USER_RECENT_SEARCHES_REQUEST="FETCH_USER_RECENT_SEARCHES_REQUEST";
export const FETCH_USER_RECENT_SEARCHES_SUCCESS="FETCH_USER_RECENT_SEARCHES_SUCCESS";

export const REMOVE_RECENT_SEARCH_ITEM_REQUEST="REMOVE_RECENT_SEARCH_ITEM_REQUEST";
export const REMOVE_RECENT_SEARCH_ITEM_SUCCESS="REMOVE_RECENT_SEARCH_ITEM_SUCCESS";

export const RESET_SEARCH_SUGGESTIONS_REQUEST="RESET_SEARCH_SUGGESTIONS_REQUEST";

export const CHANGE_ACTIVE_TAB="CHANGE_ACTIVE_TAB";

export const FETCH_SEARCH_RESULT_DATA_REQUEST="FETCH_SEARCH_RESULT_DATA_REQUEST";

export const FETCH_WORKKARD_SEARCH_RESULT_DATA_REQUEST="FETCH_WORKKARD_SEARCH_RESULT_DATA_REQUEST";
export const FETCH_ACTIVITY_SEARCH_RESULT_DATA_REQUEST="FETCH_ACTIVITY_SEARCH_RESULT_DATA_REQUEST";
export const FETCH_NOTES_SEARCH_RESULT_DATA_REQUEST="FETCH_NOTES_SEARCH_RESULT_DATA_REQUEST";
export const FETCH_FILES_SEARCH_RESULT_DATA_REQUEST="FETCH_FILES_SEARCH_RESULT_DATA_REQUEST";
export const FETCH_ACTIVITY_OWNER_SEARCH_RESULT_DATA_REQUEST="FETCH_ACTIVITY_OWNER_SEARCH_RESULT_DATA_REQUEST";
export const FETCH_ACTIVITY_ASSIGNEE_SEARCH_RESULT_DATA_REQUEST="FETCH_ACTIVITY_ASSIGNEE_SEARCH_RESULT_DATA_REQUEST";
export const FETCH_WORKKARD_OWNERS_SEARCH_RESULT_DATA_REQUEST="FETCH_WORKKARD_OWNERS_SEARCH_RESULT_DATA_REQUEST";

export const FETCH_WORKKARD_SEARCH_RESULT_DATA_SUCCESS="FETCH_WORKKARD_SEARCH_RESULT_DATA_SUCCESS";
export const FETCH_ACTIVITY_SEARCH_RESULT_DATA_SUCCESS="FETCH_ACTIVITY_SEARCH_RESULT_DATA_SUCCESS";
export const FETCH_NOTES_SEARCH_RESULT_DATA_SUCCESS="FETCH_NOTES_SEARCH_RESULT_DATA_SUCCESS";
export const FETCH_FILES_SEARCH_RESULT_DATA_SUCCESS="FETCH_FILES_SEARCH_RESULT_DATA_SUCCESS";
export const FETCH_ACTIVITY_OWNER_SEARCH_RESULT_DATA_SUCCESS="FETCH_ACTIVITY_OWNER_SEARCH_RESULT_DATA_SUCCESS";
export const FETCH_ACTIVITY_ASSIGNEE_SEARCH_RESULT_DATA_SUCCESS="FETCH_ACTIVITY_ASSIGNEE_SEARCH_RESULT_DATA_SUCCESS";
export const FETCH_WORKKARD_OWNERS_SEARCH_RESULT_DATA_SUCCESS="FETCH_WORKKARD_OWNERS_SEARCH_RESULT_DATA_SUCCESS";

export const FETCH_SEARCH_RESULT_DATA_SUCCESS="FETCH_SEARCH_RESULT_DATA_SUCCESS";
export const UPDATE_SEARCH_RESULT_DATA_SUCCESS="UPDATE_SEARCH_RESULT_DATA_SUCCESS";

export const HIDE_GLOBAL_SEARCH_LOADER = 'HIDE_GLOBAL_SEARCH_LOADER';
export const SHOW_GLOBAL_SEARCH_LOADER = 'SHOW_GLOBAL_SEARCH_LOADER';

export const ADD_GLOBAL_SEARCH_USAGE_REQUEST="ADD_GLOBAL_SEARCH_USAGE_REQUEST";
export const RESET_GLOBAL_SEARCH="RESET_GLOBAL_SEARCH";
export const RESET_INDIVIDUAL_GLOBAL_SEARCH="RESET_INDIVIDUAL_GLOBAL_SEARCH";

export const GET_TOPBAR_TABS_COUNT = "GET_TOPBAR_TABS_COUNT";
export const GET_TOPBAR_TABS_COUNT_SUCCESS = "GET_TOPBAR_TABS_COUNT_SUCCESS";

export const SAVE_SEARCH_STRING_REQUEST="SAVE_SEARCH_STRING_REQUEST";
